import React from 'react';
import AppChangePassword from './components';
import Layout from '../../layouts/';

const ChangePassword = () => {
    return (
        <Layout>
            <AppChangePassword />
        </Layout>
    );
};

export default ChangePassword;
